import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import BankAccountFactory from "../../Entity/Factories/BankAccountFactory";

export default function* bankAccountList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "bankAccounts");

    const bankAccounts = res.data.data.map(bankAccount => {
      return BankAccountFactory.create(bankAccount);
    });

    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_LIST_SUCCESS,
      payload: {
        bankAccounts: bankAccounts
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, bankAccounts);
    }

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });

    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchBankAccountList() {
  yield takeEvery(Constants.GLOBAL_BANK_ACCOUNT_LIST, bankAccountList);
}
